import React, { useState, useEffect } from "react";
import { Grid, Typography, MenuItem } from "@material-ui/core";
import Card from "../../StyledComponents/Card/Card";
import CardHeader from "../../StyledComponents/Card/CardHeader";
import CardText from "../../StyledComponents/Card/CardText";
import CardBody from "../../StyledComponents/Card/CardBody";
import { getVendorDetail } from "../Invoices/actions";
import { blockedUserData } from "./actions";
import VendorAccessTable from "./VendorAccessTable";
import {
  Autocomplete,
  Button,
  TablePagination,
  TextField,
} from "@material-ui/core";
import { VendorAccessPOPUP } from "./changeVendorAccessPopUP";
import CustomSnackbar from "../../CustomSnackbar";

const VendorAccessLandingPage = () => {
  const [vendors, setVendors] = useState([]);
  const [invoicesList, setInvoicesList] = useState([]);
  const [vendorData,setVendorData]=useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [vendorLoading, setVendorLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [changeVendorState, setChangeVendorState] = useState(false);
  const [selectedVendors, setSelectedVendors] = useState([]);
     const [waitMessage , setWaitMessage] = useState("")

  
  const invoiceAction = () => {};

  const [formState, setFormState] = useState({
    Vendor: {
      Vendor_Code: "-1",
      Vendor_Name: "All",
    },
    State: "Blocked", // ✅ Default state value
    User: null,
    InvoiceNo: "",
    OrderBy: "invoice_id",
    isAsc: "true",
    PageNo: 1,
    RowsOfPage: 25,
  });

  const handleStateChange = (event) => {
    setFormState((prevState) => ({
      ...prevState,
      State: event.target.value,
    }));
  };

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

   const handleChangePage = (e, newPage) => {
    setFormState({
      ...formState,
      PageNo: newPage + 1,
    });
  };

   const handleChangeRowsPerPage = (e) => {
    setFormState({
      ...formState,
      RowsOfPage: e.target.value,
    });
  };

  useEffect(() => {
    getVendorDetail(null, setVendors, setVendorLoading);
  }, [formState?.Vendor?.Vendor_Code, formState?.Vendor?.Vendor_Name]);


  useEffect(() => {
    setInvoicesList([]);
    blockedUserData(
      formState,
       setVendorData,
        setInvoiceLoading,
         setCount);
  }, [formState?.State, formState?.Vendor?.Vendor_Code,formState?.PageNo,formState?.RowsOfPage,formState?.isAsc,]);

useEffect(()=>{
if(waitMessage === ""){
   blockedUserData(formState ,  setVendorData,
        setInvoiceLoading,
         setCount);
}
},[waitMessage])

  return (
    <Card style={{ marginLeft: "20px" }}>
      <CardHeader color="primary" text>
        <CardText
          style={{
            backgroundColor: "#031C30",
            height: "62px",
            padding: "1px 20px",
            color: "white",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid>
              <h4>Vendor Access</h4>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>

      <CardBody>
        <form>
          <Grid container spacing={2} mt={0}>
            {/* State Dropdown */}
            <Grid item xs={12} lg={6} sm={12} md={6}>
              <Typography>Status:</Typography>
              <TextField
                select
                fullWidth
                size="small"
                value={formState.State}
                onChange={handleStateChange}
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    // marginTop: "-4px",
                    fontSize: 15,
                  },
                }}
              >
                <MenuItem value="Blocked">Blocked</MenuItem>
                <MenuItem value="Unblocked">Unblocked</MenuItem>
              </TextField>
            </Grid>
               <Grid item xs={12} lg={6} sm={12} md={6}>
                          <Typography>Vendor:</Typography>
                          <Autocomplete
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "30px",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiInputBase-input": {
                                marginTop: "-4px",
                                fontSize: 15,
                              },
                            }}
                            size="small"
                            id="Vendor"
                            options={vendors}
                            name="Vendor"
                            value={formState.Vendor}
                            getOptionLabel={(option) =>
                              option !== "" &&
                              `${
                                option?.Vendor_Code !== "-1"
                                  ? `${option?.Vendor_Code}-`
                                  : ""
                              } ${option?.Vendor_Name}`
                            }
                            onChange={(event, newValue) => {
                              autocompleteChangeHandler("Vendor", newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name=""
                                required
                                value={""}
                                onChange={(event) => {
                      getVendorDetail(
                        event.target.value,
                        setVendors,
                        setVendorLoading
                      );
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <React.Fragment>
                                      {params.InputProps.endAdornment}
                                    </React.Fragment>
                                  ),
                                }}></TextField>
                            )}></Autocomplete>
                        </Grid>
          </Grid>
          <Grid container item xs={12} sm={12} md={12} lg={12} mb={2}>
            <Grid style={{ marginRight: "20px" }}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                style={{ padding: "6px", marginTop: "20px" }}
                p={4}
                onClick={() => {
                  setErrorMessage("");

                  if (selectedVendors?.length > 0) {
                    setChangeVendorState(true);
                  } else {
                    setErrorMessage(
                      "Please select at least one vendor to change the user"
                    );
                  }
                }}
              >
                {formState?.State === "Unblocked" ? "Block" : "UnBlock"}
              </Button>
            </Grid>
            <Grid>
              <Button
                variant="contained"
                size="small"
                color="primary"
                style={{
                  padding: "6px",
                  marginTop: "20px",
                  backgroundColor: "#9FA6B2 ",
                  color: "black",
                }}
                p={4}
                onClick={() => {
                  // setVendorsList([]);
                  setSelectedVendors([]); // Add this line to clear selections
                }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
          <VendorAccessTable
            vendorList={vendorData}
            invoicesList={invoicesList}
            setInvoicesList={setInvoicesList}
            loading={invoiceLoading}
            invoiceAction={invoiceAction}
            formState={formState}
            setFormState={setFormState}
            selectedVendors={selectedVendors}
            setSelectedVendors={setSelectedVendors}
          />
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 500, 1000]}
            component="div"
            count={count}
            rowsPerPage={formState.RowsOfPage}
            page={parseInt(formState.PageNo) - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </form>
      </CardBody>
       {errorMessage && (
              <CustomSnackbar
                open={errorMessage !== ""}
                message={errorMessage}
                handleClose={() => setErrorMessage("")}
                variant="error"
              />
            )}
      {changeVendorState && (
        <VendorAccessPOPUP
          open={changeVendorState}
          close={() => setChangeVendorState(false)}
          setOpenModel =  {setChangeVendorState}
          changeVendorState = {changeVendorState}
          formState  = {formState}
          selectedVendors = {selectedVendors}
          setSelectedVendors = {setSelectedVendors}
          setWaitMessage = {setWaitMessage}
       
          />
        )
      }
    </Card>
  );
};

export default VendorAccessLandingPage;
